export enum IDisableStateByStatus {
  ACTION_END = 'ACTION_END',
}
